/* eslint space-before-function-paren: [0] */
import {
  // checkCode,
  // errorMessage,
  post
} from "@/utils/utils";

import { compact } from "lodash";
import moment from "moment";

const rules = {
  state: {
    setRulesCode: "",
    allRules: [],
    allBeltRules: [],
    invalidateRulesCode: "",
    specifiedRule: {
      couponRule: {},
      goodsList: [],
      ruleTime: []
    },
    goodsList: [],
    offlineGoodsList: [],
    serviceCategoryList: [],
    serviceProductList: [],
    editNewRulesCode: "",
    allRulesTotal: 0,
    allBeltRulesTotal: 0,
    saveSendRulesCode: "",
    guiderList: [],
    customerList: [],
    sendCouponsList: [],
    sendCouponsListTotal: 0,
    categoryList: [],
    offlineCategoryList: [],
    brandList: [],
    offlineBrandList: [],
    invalidateCouponCode: "",
    publishCouponCode: "",
    savedCoupon: {
      couponSendInfo: {},
      sendTime: [],
      ruleList: [],
      goodsList: [],
      target: [
        {
          type: 1
        }
      ]
    },
    editCouponCode: "",
    isEnableButton: false,
    sendDetail: [],
    sendDetailTotal: 0,
    detail: [],
    allDetail: [],
    detailType: [],
    detailTotal: 0,
    orders: [],
    couponSerialNumber: "",
    cancelAfterVerificationCode: "",
    couponSerialNumberCode: "",
    relateCoupons: [],
    relateCouponsTotal: 0,
    relateRuleCode: "",
    storeCouponRule: [],
    syncCouponCode: "",
    ruleValidTime: [],
    sendValidTime: [],
    writeMsg: "",
    cdkey: [],
    writeCode: "",
    setRulesResult: "",
    memberList: [],
    qrcodeUrl: "",
    categoryLen: 0,
    originCategory: [],
    storeConfig: [],
    categoryTree: [],
    bindGuiderList: "",
    bindCoupon: "",
    babyFeature: [],
    babyAgeList: [],
    pregnancyList: [],
    momFeature: [],
    babyGenderList: [],
    consumptionLevelList: [],
    customerActivityList: [],
    isVaildCouponName: "",
    isVaildCouponNameBySubmit: "",
    isVaildCouponNameByPublish: "",
    saveTabCode: "",
    modifyTabCode: "",
    removeTabCode: "",
    tabList: [],
    tabListTotal: 0,
    checkRuleValidCode: "",
    isValidRule: "",
    isValidRuleBySubmit: "",
    isValidTab: "",
    customerFeatureList: [],
    labelList: [],
    querySearchCondition: {}
  },
  mutations: {
    queryIsEnable(state, data) {
      state.isEnableButton = data;
    },
    querySearchConditionState(state, data) {
      state.querySearchCondition = data;
    },
    getAllRules(state, data) {
      state.allRules = data.result.records;
      state.allRulesTotal = data.result.total;
      state.allRules.forEach(item => {
        let records = [];
        item.labelMap &&
          item.labelMap.forEach(v => {
            records.push(v.labelName);
          });
        item.labelName = records.toString();
        if (item.useInTime >= 24) {
          item.useInTime = Number.isInteger(item.useInTime / 24)
            ? item.useInTime / 24 + "天"
            : Math.floor(item.useInTime / 24) +
              "天" +
              (item.useInTime % 24) +
              "小时";
        } else {
          item.useInTime = item.useInTime ? item.useInTime + "小时" : "";
        }
        item.validTime =
          item.ruleStartDate &&
          item.ruleEndDate &&
          item.ruleStartDate + "至" + item.ruleEndDate;
        switch (item.status) {
          case 0:
            item.statusFormat = "未开始";
            break;
          case 1:
            item.statusFormat = "进行中";
            break;
          case 2:
            item.statusFormat = "已作废";
            break;
          default:
            break;
        }
        switch (item.useRank) {
          case 0:
            item.useRankFormat = "通用";
            break;
          case 1:
            item.useRankFormat = "微店";
            break;
          case 2:
            item.useRankFormat = "门店";
            break;
          default:
            break;
        }
        switch (item.platform) {
          case 0:
            item.platformFormat = "禾苗主系统";
            break;
          case 1:
            item.platformFormat = "服务";
            break;
          case 2:
            item.platformFormat = "嘉年华";
            break;
          default:
            item.platformFormat = "禾苗主系统";
            break;
        }
        //
        if (item.ruleEndTime && item.ruleStartTime) {
          // 获取时间列表
          const endTimeList = compact(item.ruleEndTime.split(",")).sort();
          const startTimeList = compact(item.ruleStartTime.split(",")).sort();
          // 获取最大结束时间 和最小开始时间
          const startTimeListMax = startTimeList[0];
          const endTimeListMax = endTimeList[endTimeList.length - 1];
          const startDate =
            item.ruleStartDate +
            (startTimeListMax ? " " + startTimeListMax : "");
          const endDate =
            item.ruleEndDate + (endTimeListMax ? " " + endTimeListMax : "");
          if (moment().isBefore(moment(startDate, moment.ISO_8601))) {
            item.statusFormat = "未开始";
          } else if (
            moment().isAfter(moment(endDate, moment.ISO_8601)) &&
            item.status !== 2
          ) {
            item.statusFormat = "已过期";
          }
        }
        switch (item.statusFormat) {
          case "未开始":
            item.couponStatus = 0;
            break;
          case "进行中":
            item.couponStatus = 1;
            break;
          default:
            item.couponStatus = "null";
            break;
        }
        item.isPlusFormat =
          item.isPlus === 0
            ? "PLUS会员"
            : item.isPlus === 1
            ? "全部会员"
            : "全部会员";
      });
    },
    getAllBeltRules(state, data) {
      // state.allBeltRules = data.result.records;
      // state.allBeltRulesTotal = data.result.total;
      // state.allBeltRules.forEach(item => {
      //   let records = [];
      //   item.labelMap &&
      //     item.labelMap.forEach(v => {
      //       records.push(v.labelName);
      //     });
      //   item.labelName = records.toString();
      //   if (item.useInTime >= 24) {
      //     item.useInTime = Number.isInteger(item.useInTime / 24)
      //       ? item.useInTime / 24 + "天"
      //       : Math.floor(item.useInTime / 24) +
      //         "天" +
      //         (item.useInTime % 24) +
      //         "小时";
      //   } else {
      //     item.useInTime = item.useInTime ? item.useInTime + "小时" : "";
      //   }
      //   item.validTime =
      //     item.ruleStartDate &&
      //     item.ruleEndDate &&
      //     item.ruleStartDate + "至" + item.ruleEndDate;
      //   switch (item.status) {
      //     case 0:
      //       item.statusFormat = "未开始";
      //       break;
      //     case 1:
      //       item.statusFormat = "进行中";
      //       break;
      //     case 2:
      //       item.statusFormat = "已作废";
      //       break;
      //     default:
      //       break;
      //   }
      //   switch (item.useRank) {
      //     case 0:
      //       item.useRankFormat = "通用";
      //       break;
      //     case 1:
      //       item.useRankFormat = "微店";
      //       break;
      //     case 2:
      //       item.useRankFormat = "门店";
      //       break;
      //     default:
      //       break;
      //   }
      //   switch (item.platform) {
      //     case 0:
      //       item.platformFormat = "禾苗主系统";
      //       break;
      //     case 1:
      //       item.platformFormat = "服务";
      //       break;
      //     case 2:
      //       item.platformFormat = "嘉年华";
      //       break;
      //     default:
      //       item.platformFormat = "禾苗主系统";
      //       break;
      //   }
      //   //
      //   if (item.ruleEndTime && item.ruleStartTime) {
      //     // 获取时间列表
      //     const endTimeList = compact(item.ruleEndTime.split(",")).sort();
      //     const startTimeList = compact(item.ruleStartTime.split(",")).sort();
      //     // 获取最大结束时间 和最小开始时间
      //     const startTimeListMax = startTimeList[0];
      //     const endTimeListMax = endTimeList[endTimeList.length - 1];
      //     const startDate =
      //       item.ruleStartDate +
      //       (startTimeListMax ? " " + startTimeListMax : "");
      //     const endDate =
      //       item.ruleEndDate + (endTimeListMax ? " " + endTimeListMax : "");
      //     if (moment().isBefore(moment(startDate, moment.ISO_8601))) {
      //       item.statusFormat = "未开始";
      //     } else if (
      //       moment().isAfter(moment(endDate, moment.ISO_8601)) &&
      //       item.status !== 2
      //     ) {
      //       item.statusFormat = "已过期";
      //     }
      //   }
      //   switch (item.statusFormat) {
      //     case "未开始":
      //       item.couponStatus = 0;
      //       break;
      //     case "进行中":
      //       item.couponStatus = 1;
      //       break;
      //     default:
      //       item.couponStatus = "null";
      //       break;
      //   }
      //   item.isPlusFormat =
      //     item.isPlus === 0
      //       ? "PLUS会员"
      //       : item.isPlus === 1
      //       ? "全部会员"
      //       : "全部会员";
      // });
    },
    querySmgLabel(state, data) {
      state.labelList = data.result;
    },
    setRules(state, data) {
      state.setRulesCode = data.code;
      state.setRulesResult = data.result;
    },
    queryRelateRule(state, data) {
      state.relateCoupons = data.result.records;
      state.relateCouponsTotal = data.result.total;
    },
    relateRule(state, data) {
      state.relateRuleCode = data.code;
    },
    invalidateRules(state, data) {
      state.invalidateRulesCode = data.code;
    },
    // editAllrules(state, data) {
    //   state.editAllrules = data.code
    // },
    querySpecifiedRule(state, data) {
      state.specifiedRule = data.result;
    },
    queryGoodsList(state, data) {
      state.goodsList = data.result.items;
    },
    queryOfflineGoodsList(state, data) {
      state.offlineGoodsList = data.result.items;
    },
    editNewRules(state, data) {
      state.editNewRulesCode = data.code;
    },
    // publishSendRule(state, data) {
    //   state.publishSendRuleCode = data.code
    // },
    saveSendRules(state, data) {
      state.saveSendRulesCode = data.code;
    },
    queryGuider(state, data) {
      state.guiderList = data.result;
    },
    queryCustomer(state, data) {
      state.customerList = data.result;
    },
    querySendCoupons(state, data) {
      data.result.records.forEach(v => {
        // this.$set(v, "edit_enddate", true);
        v.edit_enddate = true;
        v.edit_name = true;
        v.isShow = true;
      });
      state.sendCouponsList = data.result.records;

      state.sendCouponsListTotal = data.result.total;
      state.sendCouponsList.forEach(v => {
        v.edit_enddate = true;
        v.edit_name = true;

        if (v.event === "luckyDraw") {
          v.sendNumFormat = "不限量";
        } else {
          v.sendNumFormat =
            v.sendNum === 9999999 || v.sendWayType === 1 ? "不限量" : v.sendNum;
        }

        v.sendDate =
          v.sendStartDate && v.sendEndDate
            ? v.sendStartDate + "至" + v.sendEndDate
            : v.createTime;
        switch (v.status) {
          case 0:
            v.statusFormat = "待发布";
            break;
          case 1:
            v.statusFormat = "发放中";
            break;
          case 2:
            v.statusFormat = "发布成功";
            break;
          case 3:
            v.statusFormat = "已作废";
            break;
          default:
            break;
        }
        if (v.sendEndDate && v.sendStartDate) {
          const endTimeList = compact(v.sendEndTime.split(",")).sort();
          const endTimeListMax = endTimeList[endTimeList.length - 1];
          const endDate =
            v.sendEndDate + (endTimeListMax ? " " + endTimeListMax : "");
          if (moment().isAfter(moment(endDate, moment.ISO_8601))) {
            v.status = 3;
            v.statusFormat = "已过期";
            v.isExpired = true;
          }
        }
        v.createTimeFormat = moment(v.createTime).format("YYYY-MM-DD HH:mm:ss");
        // switch (String(v.couponSendTarget) || String(v.type)) {
        //   case '0':
        //     v.typeFormat = '所有用户'
        //     break
        //   case '1':
        //     v.typeFormat = '指定用户'
        //     break
        //   case '2':
        //     v.typeFormat = '指定导购'
        //     break
        //   default:
        //     v.typeFormat = '所有用户'
        //     break
        // }
        switch (v.sendWayType) {
          case 0:
            v.sendWayTypeFormat = "自动发放";
            break;
          case 1:
            v.sendWayTypeFormat = "手动发放";
            break;
          case 2:
            v.sendWayTypeFormat = "自助领券";
            break;
          case 3:
            v.sendWayTypeFormat = "兑换码领取";
            break;
          case 4:
            v.sendWayTypeFormat = "活动发放";
            break;
          case 5:
            v.sendWayTypeFormat = "内测发券";
            break;
          default:
            break;
        }
        switch (v.event) {
          case "PasswordRedEnvelope":
            v.eventFormat = "口令红包";
            break;
          case "bigturntable":
            v.eventFormat = "大转盘";
            break;
          case "registe":
            if (v.bindingGuiderStatus === "yes") {
              v.eventFormat = "绑定导购";
            } else {
              v.eventFormat = "不绑定导购";
            }
            break;
          case "follow":
            v.eventFormat = "关注公众号";
            break;
          case "consumptionLevelListup":
            v.eventFormat = "升级plus会员";
            break;
          case "order":
            v.eventFormat = "交易发放";
            break;
          case "recharge":
            v.eventFormat = "充值发放";
            break;
          case "exchange":
            v.eventFormat = "兑换码领取";
            break;
          case "manual":
            switch (
              (v.couponSendTarget && String(v.couponSendTarget)) ||
              (v.type && String(v.type))
            ) {
              case "0":
                v.eventFormat = "所有用户";
                break;
              case "1":
                v.eventFormat = "指定用户";
                break;
              case "2":
                v.eventFormat = "指定导购";
                break;
              case "3":
                v.eventFormat = "指定门店";
                break;
              case "4":
                v.eventFormat = "导入用户";
                break;
              default:
                v.eventFormat = "所有用户";
                break;
            }
            // v.eventFormat = '手动发放'
            break;
          case "fetch":
            if (v.isActivity === 0) {
              v.eventFormat = "个人中心领券";
              if (v.isPlus === 0) {
                v.eventFormat = "PLUS会员领券";
              }
            } else {
              if (v.isGuider === 0) {
                v.eventFormat = "导购中心领券";
              } else {
                v.eventFormat = "活动领券";
              }
            }
            break;
          case "orderOffline":
            v.eventFormat = "线下交易";
            break;
          case "marketing":
            v.eventFormat = "营销审核发券";
            break;
          case "orderOnline":
            v.eventFormat = "线上交易";
            break;
          // case "guider":
          //   v.eventFormat = "绑定导购";
          //   break;
          case "exchangeByPoint":
            v.eventFormat = "积分兑换";
            break;
          case "carnival":
            v.eventFormat = "满额发券";
            break;
          case "luckyDraw":
            v.eventFormat = "抽奖发券";
            break;
          case "self":
            if (v.isActivity === 0) {
              v.eventFormat = "个人中心领券";
              if (v.isPlus === 0) {
                v.eventFormat = "PLUS会员领券";
              }
            } else {
              if (v.isGuider === 0) {
                v.eventFormat = "导购中心领券";
              } else {
                v.eventFormat = "活动领券";
              }
            }
            break;
          default:
            break;
        }
      });
    },
    QUERY_SINGLE_COUPON_LIST() {},
    SEND_TIME_EDIT() {},
    queryCategory(state, data) {
      state.categoryList = data.result;
    },
    queryOfflineCategory(state, data) {
      state.categoryLen = data.result.offLineCategoryNodes.length;
      state.originCategory = data.result.offLineCategoryNodes;
      const records = data.result.offLineCategoryNodes;

      function transTreeData(items) {
        if (items.length > 0) {
          const curPid = "0"; // pId=0，为最上层节点 ，即无父节点
          const parent = findChild(curPid); // 数组
          return parent;
        } else {
          return [];
        }
      }
      // 找子节点
      function findChild(curPid) {
        const _arr = [];
        const items = records;
        const length = items.length;
        for (let i = 0; i < length; i++) {
          if (items[i].pId === curPid) {
            const _obj = items[i];
            _obj.children = findChild(_obj.id);
            _arr.push(_obj);
          }
        }
        return _arr;
      }
      state.offlineCategoryList = transTreeData(records);
    },
    queryBrand(state, data) {
      state.brandList = data.result;
    },
    queryOfflineBrand(state, data) {
      state.offlineBrandList = data.result;
    },
    invalidateCoupon(state, data) {
      state.invalidateCouponCode = data.code;
    },
    publishCoupon(state, data) {
      state.publishCouponCode = data.code;
    },
    querySavedCoupon(state, data) {
      state.savedCoupon = data.result;
    },
    editCoupon(state, data) {
      state.editCouponCode = data.code;
    },
    querySendDetail(state, data) {
      state.sendDetail = data.result.records;
      state.sendDetailTotal = data.result.total;
      state.sendDetail.forEach(v => {
        switch (v.useRank) {
          case "0":
            v.useRankFormat = "通用";
            break;
          case "1":
            v.useRankFormat = "微店";
            break;
          case "2":
            v.useRankFormat = "门店";
            break;
          default:
            break;
        }
        v.sendDate =
          v.sendStartDate &&
          v.sendEndDate &&
          v.sendStartDate + "至" + v.sendEndDate;
      });
    },
    getDetail(state, data) {
      state.detail = data.result.pageModel ? data.result.pageModel.records : [];
      state.detailType = data.result.Num;
      state.detailTotal = data.result.pageModel
        ? data.result.pageModel.total
        : 0;
      state.detail.forEach(v => {
        v.isVerification =
          v.isVerification && v.isVerification === 0 ? "待核销" : "已核销";
        switch (v.status) {
          case "":
            v.status = "全部";
            break;
          case 0:
            v.status = "已领取";
            break;
          case 2:
            v.status = "已使用";
            break;
          case 3:
            v.status = "待领取";
            break;
          case 4:
            v.status = "未使用";
            break;
          case 5:
            v.status = "冻结";
            break;
          default:
            break;
        }
        v.updateTimeFormat = v.updateTime
          ? moment(v.updateTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
        v.createTimeFormat = v.createTime
          ? moment(v.createTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
      });
    },
    getAllDetail(state, data) {
      state.allDetail = data.result.pageModel
        ? data.result.pageModel.records
        : [];
      state.allDetail.forEach(v => {
        v.isVerification =
          v.isVerification && v.isVerification === 0 ? "待核销" : "已核销";
        switch (v.status) {
          case "":
            v.status = "全部";
            break;
          case 0:
            v.status = "已领取";
            break;
          case 2:
            v.status = "已使用";
            break;
          case 3:
            v.status = "待领取";
            break;
          case 4:
            v.status = "未使用";
            break;
          case 5:
            v.status = "冻结";
            break;
          default:
            break;
        }
        v.createTimeFormat = v.createTime
          ? moment(v.createTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
        v.updateTimeFormat =
          v.updateTime && moment(v.updateTime).format("YYYY-MM-DD HH:mm:ss");
      });
    },
    queryOrders(state, data) {
      state.orders = data.result;
    },
    cancelAfterVerification(state, data) {
      state.cancelAfterVerificationCode = data.code;
    },
    queryStoreCouponRule(state, data) {
      state.storeCouponRule = data.result;
    },
    syncCoupon(state, data) {
      state.syncCouponCode = data.code;
    },
    getRuleValidTime(state, data) {
      state.ruleValidTime = data.result;
    },
    getSendValidTime(state, data) {
      state.sendValidTime = data.result;
    },
    getCdkey(state, data) {
      data.result.forEach((v, i) => {
        switch (v.status) {
          case 3:
            v.statusFormat = "待兑换";
            break;
          case 4:
            v.statusFormat = "已兑换";
            break;
          default:
            break;
        }
        v.index = i + 1;
      });
      state.cdkey = data.result;
    },
    writeOfflineRules(state, data) {
      state.writeCode = data.code;
      state.writeMsg = data.outMsg;
    },
    queryUrl(state, data) {
      state.qrcodeUrl = data.result;
    },
    queryStoreConfig(state, data) {
      state.storeConfig = (data.result && data.result.value.split(",")) || [];
    },
    getCategoryTree(state, data) {
      state.categoryTree = data.result.result;
    },
    queryBindGuider(state, data) {
      state.bindGuiderList = data.result;
    },
    queryBindCoupon(state, data) {
      state.bindCoupon = data.result;
    },
    querySpecialTarget(state, data) {
      const baby = [];
      const mom = [];
      const babyGenderList = [];
      const consumptionLevelList = [];
      const customerActivityList = [];
      data.result.forEach(v => {
        v.featureCode.includes("F01") && v.parentId && babyGenderList.push(v);
        v.featureCode.includes("F02") && v.parentId && baby.push(v);
        v.featureCode.includes("F03") &&
          v.parentId &&
          consumptionLevelList.push(v);
        v.featureCode.includes("F04") && v.parentId && mom.push(v);
        v.featureCode.includes("F05") &&
          v.parentId &&
          customerActivityList.push(v);
      });
      state.customerFeatureList = data.result;
      state.babyGenderList = babyGenderList;
      state.babyFeature = baby;
      state.babyAgeList = baby;
      state.consumptionLevelList = consumptionLevelList;
      state.momFeature = mom;
      state.pregnancyList = mom;
      state.customerActivityList = customerActivityList;
    },
    checkCouponName(state, data) {
      state.isVaildCouponName = data.result;
    },
    checkCouponNameBySubmit(state, data) {
      state.isVaildCouponNameBySubmit = data.result;
    },
    checkCouponNameByPublish(state, data) {
      state.isVaildCouponNameByPublish = data.result;
    },
    queryTab(state, data) {
      data.result &&
        data.result.records.forEach(v => {
          v.creatTimeFormat = moment(v.createTime).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
      state.tabList = data.result ? data.result.records : [];
      state.tabListTotal = data.result ? data.result.total : 0;
    },
    saveTab(state, data) {
      state.saveTabCode = data.code;
    },
    modifyTab(state, data) {
      state.modifyTabCode = data.code;
    },
    removeTab(state, data) {
      state.removeTabCode = data.code;
    },
    checkRuleValid(state, data) {
      state.isValidRule = data.result;
    },
    checkRuleValidBySubmit(state, data) {
      state.isValidRuleBySubmit = data.result;
    },
    checkTabValid(state, data) {
      state.isValidTab = data.result;
    },
    queryServiceCategoryList(state, data) {
      state.serviceCategoryList = data.result;
    },
    queryServiceProductList(state, data) {
      state.serviceProductList = data.result;
    },
    CREATE_COUPON_QRCODE() {},
    QUERY_COUPON_LV_LIST() {},
    QUERY_PAS_LV_LIST() {},
    QUERY_PHYSIOLOGICAL_AROUP_TYPE_LIST() {},
    GET_COUPON_INFO() {},
    STORE_DICT_ITEMS() {},
    GET_PARAM_VALUE_ALLOW_NULL() {},
    UPDATE_OFFLINE_TYPE_CODE() {},
    SAVE_QRCODE_DATA_RETURN_IMG() {},
  },
  actions: {
    querySingleCouponList({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendByIdNoPage`,
        name: "QUERY_SINGLE_COUPON_LIST",
        params
      });
    },
    createCouponQrcode({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/createCouponQrCode`,
        name: "CREATE_COUPON_QRCODE",
        params
      });
    },
    queryServiceCategoryList({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/server_category_list`,
        name: "queryServiceCategoryList",
        params
      });
    },
    queryServiceProductList({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/server_product_list`,
        name: "queryServiceProductList",
        params
      });
    },
    checkRuleValidBySubmit({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_rule_name`,
        name: "checkRuleValidBySubmit",
        params
      });
    },
    checkRuleValid({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_rule_name`,
        name: "checkRuleValid",
        params
      });
    },
    checkTabValid({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_label_name`,
        name: "checkTabValid",
        params
      });
    },
    queryTab({ commit }, params) {
      return post({
        commit,
        url: `/couponLabelBack/queryLabel`,
        name: "queryTab",
        params
      });
    },
    saveTab({ commit }, params) {
      return post({
        commit,
        url: `/couponLabelBack/add`,
        name: "saveTab",
        params
      });
    },
    modifyTab({ commit }, params) {
      return post({
        commit,
        url: `/couponLabelBack/edit`,
        name: "modifyTab",
        params
      });
    },
    checkCouponName({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendByName`,
        name: "checkCouponName",
        params
      });
    },
    // 为了保存或复制时验证优惠券发放名称是否重复
    checkCouponNameBySubmit({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendByName`,
        name: "checkCouponNameBySubmit",
        params
      });
    },
    // 为了发布时验证优惠券发放名称是否重复
    checkCouponNameByPublish({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendByName`,
        name: "checkCouponNameByPublish",
        params
      });
    },
    querySpecialTarget({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/customer_feature`,
        name: "querySpecialTarget",
        params
      });
    },
    queryBindGuider({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_send_store_user`,
        name: "queryBindGuider",
        params
      });
    },
    queryBindCoupon({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_send_guider`,
        name: "queryBindCoupon",
        params
      });
    },
    getCategoryTree({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/get_category_offline`,
        name: "getCategoryTree",
        params
      });
    },
    queryStoreConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "queryStoreConfig",
        params
      });
    },
    queryUrl({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/get_url`,
        name: "queryUrl",
        params
      });
    },
    writeOfflineRules({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/write_coupon_rule`,
        name: "writeOfflineRules",
        params
      });
    },
    getCdkey({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_coupon_code`,
        name: "getCdkey",
        params
      });
    },
    getRuleValidTime({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_rule_date_time`,
        name: "getRuleValidTime",
        params
      });
    },
    getSendValidTimes({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/query_send_date_time`,
        name: "getSendValidTime",
        params
      });
    },
    syncCoupon({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/sync_couponType`,
        name: "syncCoupon",
        params
      });
    },
    queryStoreCouponRule({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/get_customer_coupon_rule`,
        name: "queryStoreCouponRule",
        params
      });
    },
    relateRule({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/add_toCouponRule`,
        name: "relateRule",
        params
      });
    },
    queryRelateRule({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/get_couponType`,
        name: "queryRelateRule",
        params
      });
    },
    cancelAfterVerification({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/coupon_verification`,
        name: "cancelAfterVerification",
        params
      });
    },
    queryOrders({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/get_coupon_flow`,
        name: "queryOrders",
        params
      });
    },
    getDetail({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/couponSendDetail`,
        name: "getDetail",
        params
      });
    },
    getAllDetail({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/couponSendDetailExport`,
        name: "getAllDetail",
        params
      });
    },
    // getAllDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/storeCouponSend/couponSendDetail`,
    //     name: "getAllDetail",
    //     params
    //   });
    // },
    querySendDetail({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/findCouponSendById`,
        name: "querySendDetail",
        params
      });
    },
    editCoupon({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/modifySend`,
        name: "editCoupon",
        params
      });
    },
    publishCoupon({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/send`,
        name: "publishCoupon",
        params
      });
    },
    querySavedCoupon({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/copySend`,
        name: "querySavedCoupon",
        params
      });
    },
    invalidateCoupon({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/invalidSend`,
        name: "invalidateCoupon",
        params
      });
    },
    queryCategory({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_category`,
        name: "queryCategory",
        params
      });
    },
    queryBrand({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_brand`,
        name: "queryBrand",
        params
      });
    },
    queryOfflineCategory({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_category_offline`,
        name: "queryOfflineCategory",
        params
      });
    },
    queryOfflineBrand({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_brand_offline`,
        name: "queryOfflineBrand",
        params
      });
    },
    querySendCoupons({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/selectSend`,
        name: "querySendCoupons",
        params
      });
    },
    queryCustomer({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_member_offline`,
        name: "queryCustomer",
        params
      });
    },
    saveSendRules({ commit }, params) {
      return post({
        commit,
        url: `/storeCouponSend/saveSend`,
        name: "saveSendRules",
        params
      });
    },
    editNewRules({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/update_coupon_rule`,
        name: "editNewRules",
        params
      });
    },
    queryGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_goods`,
        name: "queryGoodsList",
        params
      });
    },
    queryOfflineGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_goods_offline`,
        name: "queryOfflineGoodsList",
        params
      });
    },
    getAllRules({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/select_rule`,
        name: "getAllRules",
        params
      });
    },
    getAllBeltRules({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/select_rule_belt`,
        name: "getAllBeltRules",
        params
      });
    },
    querySmgLabel({ commit }, params) {
      return post({
        commit,
        url: `/couponLabelNew/querySmgLabel`,
        name: "querySmgLabel",
        params
      });
    },
    invalidateRules({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/operate_rule`,
        name: "invalidateRules",
        params
      });
    },
    setRules({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/save_rule`,
        name: "setRules",
        params
      });
    },
    querySpecifiedRule({ commit }, params) {
      return post({
        commit,
        url: `/couponRule/query_rule_id`,
        name: "querySpecifiedRule",
        params
      });
    },
    queryGoodsSnOffline({ commit }, params) {
      return post({
        commit,
        url: `hemiao/common/import_goods_offline`,
        name: "querySpecifiedRule",
        params
      });
    },
    queryCouponLevelList({ commit }, params) {
      return post({
        commit,
        url: `/store/dict/item/list`,
        name: "QUERY_COUPON_LV_LIST",
        params
      });
    },
    queryPasList({ commit }, params) {
      return post({
        commit,
        url: `/store/dict/item/list`,
        name: "QUERY_PAS_LV_LIST",
        params
      });
    },
    queryPhysiologicalAroupTypelList({ commit }, params) {
      return post({
        commit,
        url: `/physiological/axis/back/table_name/list`,
        name: "QUERY_PHYSIOLOGICAL_AROUP_TYPE_LIST",
        params
      });
    },
    getCouponInfo({ commit }, params) {
      return post({
        commit,
        url: `/backendCoupon/getCouponInfoByCouponCode`,
        name: "GET_COUPON_INFO",
        params
      });
    },
    send_time_edit({ commit }, params) {   //修改时间
      return post({
        commit,
        url: `/storeCouponSend/send_time_edit`,
        name: "SEND_TIME_EDIT",
        params
      });
    },
    storeDictItems({ commit }, params) {   //数据字典
      return post({
        commit,
        url: `/sys/common/store_dict_items`,
        name: "STORE_DICT_ITEMS",
        params
      });
    },
    getParamValueAllowNull({ commit }, params) {   //数据字典
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/getParamValueAllowNull`,
        name: "GET_PARAM_VALUE_ALLOW_NULL",
        params
      });
    },
    updateOfflineTypeCode({ commit }, params) {   //数据字典
      return post({
        commit,
        url: `/couponRule/update_offline_type_code`,
        name: "UPDATE_OFFLINE_TYPE_CODE",
        params
      });
    },
    saveQrcodeDataReturnImg({ commit }, params) {   //数据字典
      return post({
        commit,
        url: `/micro/qrcode/saveQrcodeDataReturnImg`,
        name: "SAVE_QRCODE_DATA_RETURN_IMG",
        params
      });
    },
  }
};
export default rules;
